import { render, staticRenderFns } from "./manage-integration-service-layout.vue?vue&type=template&id=a063afd6&scoped=true"
import script from "./manage-integration-service-layout.vue?vue&type=script&lang=js"
export * from "./manage-integration-service-layout.vue?vue&type=script&lang=js"
import style0 from "./manage-integration-service-layout.vue?vue&type=style&index=0&id=a063afd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a063afd6",
  null
  
)

export default component.exports